<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 4; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn">
      <div class="cf-header gap-10 d-flex align-items-center">
        <img
          @click="goBack()"
          src="../../assets/img/feedbackform/backarrow.svg"
          class="pointer"
          alt
        />
        <span>Bookmarks</span>
      </div>
      <div
        class="teams-main-container mt-3 d-flex relativeclass"
        style="height: calc(100vh - 174px)"
      >
        <div
          v-if="
            !searchLoading && !LoaderStatus && !folders.length && !searchFolder
          "
          class="d-flex flex-column align-blur-img"
        >
          <template v-if="searchQuery">
            <img src="@/assets/img/accessconnew/emptyprivilageBig.svg" alt />
            <div class="teams-empty-container-font mt-3">
              No matching results for "{{ searchQuery }}"
            </div>
          </template>
          <template v-else>
            <img
              src="../../assets/New-imgs/teams-icons/teams_tree_empty.svg"
              alt
            />
            <div class="teams-empty-container-font mt-3">
              There are no bookmark folders.
            </div>
          </template>
        </div>
        <template v-else>
          <div
            class="teams-left-container"
            id="style-scrollbar"
            style="height: calc(100vh - 208px)"
          >
            <div class="relativeclass teams-innerInputField">
              <img
                class="teams-setImage"
                src="../../assets/img/search-bar-icon.svg"
                alt
              />

              <b-form-input
                v-model.trim="searchFolder"
                placeholder="Search Folders"
                type="search"
                @update="(searchLoading = true), getBookmarkFolders()"
                :debounce="500"
                class="search-input"
              ></b-form-input>
            </div>

            <hr class="mb-2" />
            <div class="mb-2 teams-group-head">Bookmark Folders</div>
            <div
              class="teams-group-container-height"
              id="teams-group-scrollbar"
            >
              <div
                v-if="searchFolder !== '' && folders.length == 0"
                class="
                  d-flex
                  h-100
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  src="@/assets/New-imgs/teams-icons/teams-no-matching-results.svg"
                  alt
                />
                <div class="teams-empty-container-font mt-3">
                  No matching results for "{{ searchFolder }}"
                </div>
              </div>
              <template v-else>
                <section
                  class="
                    w-100
                    d-flex
                    align-items-center
                    justify-content-between
                    bookmark-left-unselectedcard
                    pointer
                  "
                  :class="{
                    'mt-3': index > 0,
                    'bm-selected-leftcard':
                      selectedFolder.folderID == folder.folderID,
                  }"
                  v-for="(folder, index) in folders"
                  :key="folder.folderID"
                  @click="clearSelectedCand(), (selectedFolder = folder)"
                >
                  <div
                    class="fw-400 fs-14 font-lato text-truncate w-90 pr-1"
                    :class="
                      selectedFolder.folderID == folder.folderID
                        ? 'color-white'
                        : 'color-black'
                    "
                  >
                    {{ folder.folderName }}
                  </div>
                  <!-- bind bg-white wen selected -->
                  <div
                    :class="
                      selectedFolder.folderID == folder.folderID && 'bg-white'
                    "
                    class="
                      bookmark-card-tag
                      d-flex
                      align-items-center
                      justify-content-center
                      fw-500
                      fs-13
                      color-mainblue
                      font-lato
                    "
                  >
                    {{ folder.usersCount }}
                  </div>
                </section>
              </template>
            </div>
          </div>
          <div class="teams-new-right-container ml-2 overflow-hidden">
            <div
              v-if="!selectedFolder.folderID"
              class="align-content-center h-100"
            >
              <img
                src="../../assets/New-imgs/teams-icons/teams_no_folder_selected.svg"
                alt
              />
              <div class="teams-empty-container-font mt-3">
                Please select any folder on the left side to view the
                <br />candidates that have been added to it.
              </div>
            </div>
            <template v-else>
              <section
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center w-45 newtp-checkbox">
                  <b-form-checkbox
                    v-model="allSelected"
                    @change="selectAll()"
                    v-if="selectedFolder.usersCount != 0"
                  ></b-form-checkbox>
                  <h6
                    class="
                      fw-600
                      fs-20
                      font-lato
                      color-mainblue
                      ml-2
                      m-0
                      text-truncate
                    "
                    style="min-width: auto; max-width: 60%"
                  >
                    {{ selectedFolder.folderName }}
                  </h6>
                  <img
                    @click="editBookmark()"
                    src="../../assets/img/bookmarks/edit.svg"
                    class="ml-2 pointer"
                    alt
                  />
                  <div
                    class="
                      bm-usertag
                      fs-14
                      fw-600
                      font-mont
                      color-mainblue
                      ml-3
                    "
                  >
                    <img
                      src="../../assets/img/bookmarks/noofuser.svg"
                      class
                      alt
                    />
                    {{ selectedFolder.usersCount }}
                  </div>
                </div>
                <div class="d-flex align-items-center gap-15">
                  <b-button
                    class="acs-addBtn-modal padding-6-19"
                    @click="showConfirm('deleteFolder')"
                    >Delete Folder</b-button
                  >
                  <b-button
                    v-if="selectedFolder.userDetails.length != 0"
                    class="acs-addBtn-modal padding-6-19"
                    :disabled="selectedCands.length == 0"
                    @click="
                      selectedCands.length != 0
                        ? showConfirm('removeBookmark')
                        : ''
                    "
                    >Remove Bookmark</b-button
                  >
                  <b-button
                    v-if="
                      selectedFolder.userDetails.length != 0 &&
                      roles.includes('TRIGGER_CVS')
                    "
                    class="acs-addBtn-modal padding-6-19"
                    :disabled="selectedCands.length == 0"
                    @click="selectedCands.length != 0 ? openTriggerCVS() : ''"
                    >Trigger CVS</b-button
                  >
                  <b-button
                    v-if="selectedFolder.userDetails.length != 0"
                    class="
                      acs-addBtn-modal
                      padding-6-19
                      disjdbtn
                      d-flex
                      align-items-center
                      mr-3
                    "
                    @click="showAddToJd = true"
                    :disabled="selectedCands.length == 0"
                  >
                    <img
                      src="../../assets/img/accessconnew/whitePlus.svg"
                      alt
                      class="mr-2"
                    />
                    <span class>Add to Job</span>
                  </b-button>
                </div>
              </section>
              <hr class="w-100" />
              <section
                class="w-100 overflow-auto p-2"
                style="height: calc(100vh - 300px)"
              >
                <div
                  class="
                    d-flex
                    align-items-center
                    flex-column
                    h-100
                    justify-content-center
                  "
                  v-if="selectedFolder.userDetails.length == 0"
                >
                  <img
                    src="@/assets/New-imgs/teams-icons/teams_no_folder_content.svg"
                    alt
                  />
                  <div class="teams-empty-container-font mt-3">
                    There are no candidates in this folder.
                  </div>
                </div>
                <template v-else>
                  <!-- bind mt-3 index>0 -->
                  <div
                    class="
                      bookmark-right-cards
                      d-flex
                      align-items-center
                      fs-15
                      fw-400
                      font-lato
                      color-mainblue
                      w-100
                      position-relative
                    "
                    :class="index > 0 && 'mt-3'"
                    v-for="(cand, index) in selectedFolder.userDetails"
                    :key="cand.candidateID"
                  >
                    <div class="bookmark-blue-line"></div>
                    <b-form-checkbox
                      :value="cand.candidateID"
                      v-model="selectedCands"
                      @change="deselect()"
                      class="newtp-checkbox"
                    ></b-form-checkbox>
                    <div class="w-35 text-truncate pr-2">
                      <span v-b-tooltip.hover="cand.name">{{ cand.name }}</span>
                    </div>
                    <div class="w-35 text-truncate pr-2">
                      <span v-b-tooltip.hover="cand.email">{{
                        cand.email
                      }}</span>
                    </div>
                    <div class="w-20">{{ cand.phoneNumber }}</div>
                    <div class="d-flex align-items-center gap-10">
                      <img
                        v-b-tooltip.hover.top="'View'"
                        @click="viewCandidate(cand)"
                        class="pointer"
                        src="../../assets/img/bookmarks/view.svg"
                        alt
                      />
                      <img
                        v-if="roles.includes('PUT_CANDIDATE') && cand.active"
                        @click="
                          cand.active && cand.isEditable
                            ? editCandidate(cand)
                            : ''
                        "
                        v-b-tooltip.hover.top="
                          cand.active && cand.isEditable
                            ? 'Edit'
                            : 'You don\'t have permission to edit this candidate'
                        "
                        :class="
                          cand.active && cand.isEditable
                            ? 'pointer'
                            : 'disabled-text'
                        "
                        src="../../assets/img/bookmarks/edit.svg"
                        alt
                      />
                      <img
                        v-b-tooltip.hover.top="'Activate'"
                        v-if="roles.includes('PUT_CANDIDATE') && !cand.active"
                        @click="activateCand(cand)"
                        src="../../assets/talentpool/disableEdit.svg"
                        class="pointer"
                        alt=""
                      />
                      <img
                        @click="exportResume(cand)"
                        v-b-tooltip.hover.top="'Download Resume'"
                        class="pointer"
                        src="../../assets/img/bookmarks/download.svg"
                        alt
                      />
                    </div>
                  </div>
                </template>
              </section>
            </template>
          </div>
        </template>
      </div>
    </div>
    <b-modal
      id="editbookmark"
      centered
      hide-footer
      hide-header
      @hidden="closeEditBookmark()"
    >
      <div class="d-flex align-items-center justify-content-between p-3">
        <div class="b-modal-header">Edit Folder Name</div>

        <div class="rotate-on-hover pointer" @click="closeEditBookmark()">
          <img src="@/assets/img/accessconnew/blueCross.svg" alt />
        </div>
      </div>
      <hr class="my-0" />
      <div class="p-3">
        <section class="mt-2 mb-3 px-2">
          <Input
            placeholder="Enter"
            label="Folder Name"
            type="text"
            id="bookmark"
            :vmodel="$v.folderName.$model"
            @select-value="$v.folderName.$model = $event"
            @handle-enter="bookmarkLoader ? '' : bookmarkCands()"
            :showError="$v.folderName.$error"
          />
          <div class="errortxt" v-if="$v.folderName.$error">
            {{
              !$v.folderName.required ? "Required" : "Max char length exceeded"
            }}
          </div>
        </section>
      </div>
      <hr class="my-0" />

      <div class="p-3 w-100 d-flex align-items-center justify-content-end">
        <div class="bluebtn d-flex align-items-center">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            @click="closeEditBookmark()"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              class="acs-addBtn-modal pl-4 pr-4"
              :class="
                bookmarkLoader
                  ? 'confirm-loader-class defaultCursor'
                  : 'pointer'
              "
              @click="bookmarkLoader ? '' : bookmarkCands()"
              >{{ bookmarkLoader ? "" : "Update" }}</b-button
            >
            <div v-if="bookmarkLoader" class="confirm-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <ConfirmModal
      v-if="confirmModal"
      @close-modal="closeDeleteModal()"
      @handle-submit="deleteFolder()"
      :confirmModal="confirmModal"
      :button="confirmType == 'deleteFolder' ? 'Delete' : 'Remove'"
      from="bookmark"
      :showButtonLoader="bookmarkLoader"
      :header="getHeader"
      :msg="getMessage"
      :imageSrc="require('@/assets/img/feedbackform/confirmIcon.svg')"
    />
    <AddtoJDModal
      v-if="showAddToJd"
      :showModal="showAddToJd"
      :candidateSelected="selectedCands"
      :from="'talentpool'"
      @close-modal="(showAddToJd = false), clearSelectedCand()"
      @candidates-selected="showAddToJd = false"
    />

    <!-- Trigger CVS (job-less) for the selected bookmarked candidates -->
    <TriggerCVSModal
      v-if="showCvsTriggerModal"
      :showModal="showCvsTriggerModal"
      :roles="roles"
      :selectedCandidates="selectedCandidatesForCVS"
      :successDetails="cvsSuccessDetails"
      :submitting="cvsSubmitting"
      @trigger-cvs="triggerCVS"
      @remove-candidate="removeCvsCandidate"
      @close-modal="closeTriggerCVS"
    />

    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :selectedCandidate="selectedCandidate"
      :showNote="true"
      @close-view-icon="closeViewIcon"
      @add-note="(noteTagData = $event), addNote(selectedCandidate)"
    />

    <AddNote
      v-if="showAddNote"
      :showAddNote="showAddNote"
      :viewCandidateModal="viewCandidateModal ? false : true"
      @close-modal="closeAddNote"
      :candidateID="addNoteId"
      :noteTagData="noteTagData"
      :showAttachment="true"
    />
  </div>
</template>

<script>
import {
  getBookmarkFolders,
  addFolderUser,
  deleteFolderUser,
  getCustomerFields,
  getResume,
  trigerCvs,
} from "@/utils/apiFunctions";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import Input from "@/components/InputComponents/Input.vue";
import toast from "@/components/mixin/toast";
import { mapGetters } from "vuex";
import { maxLength, required } from "vuelidate/lib/validators";
import Loader from "@/components/fixedcomponents/Loader.vue";
import { downloadResumeFile } from "@/utils/download.js";
import ConfirmModal from "../InterviewProcess/ConfirmModal.vue";
import AddtoJDModal from "@/controllers/Talentpool/AddtoJDModal.vue";
import PreviewCandidateSidebar from "@/controllers/JD/modals/PreviewCandidateSidebar.vue";
import AddNote from "../../components/Kanban/modal/AddNoteModal.vue";
import TriggerCVSModal from "@/controllers/Talentpool/TriggerCVSModal.vue";

export default {
  name: "BookMarks",
  data() {
    return {
      showAddToJd: false,
      // Trigger CVS (job-less) from Bookmarks
      showCvsTriggerModal: false,
      cvsSubmitting: false,
      cvsSuccessDetails: null,
      cvsTriggerCandidateIDs: [],
      allSelected: false,
      LoaderStatus: false,
      bookmarkLoader: false,
      showAddNote: false,
      searchLoading: false,
      viewCandidateModal: false,
      confirmModal: false,
      confirmType: null,
      searchFolder: "",
      folderName: "",
      addNoteId: "",
      folders: [],
      selectedCands: [],
      customFieldsArray: [],
      selectedCandidate: {},
      noteTagData: {},
      selectedFolder: { userDetails: [] },
    };
  },
  mixins: [toast],
  components: {
    Input,
    Spinner,
    Loader,
    AddNote,
    ConfirmModal,
    AddtoJDModal,
    PreviewCandidateSidebar,
    TriggerCVSModal,
  },
  validations: {
    folderName: {
      maxLength: maxLength(50),
      required,
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
    }),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    ...mapGetters(["roles"]),
    // Candidates listed in the Trigger CVS popup (the selection at open time,
    // minus any removed in the popup).
    selectedCandidatesForCVS() {
      return (this.selectedFolder.userDetails || [])
        .filter((cand) =>
          this.cvsTriggerCandidateIDs.includes(cand.candidateID)
        )
        .map((cand) => ({
          candidateID: cand.candidateID,
          name: cand.name,
          email: cand.email,
        }));
    },
    getHeader() {
      let text =
        this.confirmType == "deleteFolder"
          ? "Delete Folder"
          : `Remove ${this.selectedCands.length} Candidate${
              this.selectedCands.length > 1 ? "s" : ""
            }`;
      return text;
    },
    getMessage() {
      let text =
        this.confirmType == "deleteFolder"
          ? `Are you sure you want to delete <strong> ${this.selectedFolder.folderName} </strong> folder. This action cannot be undone`
          : `Candidate${
              this.selectedCands.length > 1 ? "s" : ""
            } will be removed from <strong> ${
              this.selectedFolder.folderName
            } </strong>. They will no longer appear in this saved list.`;
      if (this.confirmType == "deleteFolder" && this.selectedFolder.usersCount)
        text = text + " and saved candidates will be removed.";
      return text;
    },
  },
  async created() {
    this.LoaderStatus = true;
    await this.getBookmarkFolders();
    this.selectedFolder = this.folders[0];
    await this.getCustomField();
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    if (this.$route.query.history) {
      this.viewCandidateModal = true;
      this.viewCandidate(this.storedData.candidate);
    }
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        this.LoaderStatus = true;
        if (newValue != "Loader") {
          this.getBookmarkFolders();
        }
      }
    },
  },
  methods: {
    activateCand(i) {
      this.$router.push({
        name: "ActivateCandidate",
        params: {
          candidateID: i.candidateID,
        },
        query: {
          fromPage: "bookmark",
          active: "" + i.active,
          folderID: this.selectedFolder.folderID,
        },
      });
    },
    goBack() {
      this.$router.push({
        name: "TalentPool",
      });
    },
    editCandidate(data) {
      this.$router.push({
        name: "EditCandidate",
        params: {
          candidateID: data.candidateID,
        },
        query: {
          fromPage: "bookmark",
          folderID: this.selectedFolder.folderID,
        },
      });
    },
    addNote(cand) {
      this.showAddNote = true;
      this.addNoteId = cand.candidateID;
    },
    closeAddNote() {
      this.noteTagData = {};
      this.showAddNote = false;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    viewCandidate(cand) {
      this.selectedCandidate = cand;
      this.viewCandidateModal = true;
    },
    openTriggerCVS() {
      this.cvsTriggerCandidateIDs = [...this.selectedCands];
      this.cvsSuccessDetails = null;
      this.showCvsTriggerModal = true;
    },
    removeCvsCandidate(candidateID) {
      this.cvsTriggerCandidateIDs = this.cvsTriggerCandidateIDs.filter(
        (id) => id !== candidateID
      );
    },
    closeTriggerCVS() {
      const triggered = !!this.cvsSuccessDetails;
      this.showCvsTriggerModal = false;
      this.cvsSuccessDetails = null;
      this.cvsSubmitting = false;
      this.cvsTriggerCandidateIDs = [];
      if (triggered) this.clearSelectedCand();
    },
    // Same job-less trigger as Talent Pool (optional skills).
    async triggerCVS(skills) {
      this.cvsSubmitting = true;
      try {
        const payload = { candidates: [...this.cvsTriggerCandidateIDs] };
        if (skills && skills.length) payload.skills = skills;
        const res = await trigerCvs(payload);
        if (res.status == 200) {
          this.cvsSuccessDetails = {
            newlyAdded: res.data.data.data.newCandidates,
            alreadyExisting: res.data.data.data.oldCandidates,
          };
        } else {
          this.errorModal("Something went wrong!");
          this.closeTriggerCVS();
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
        this.closeTriggerCVS();
      } finally {
        this.cvsSubmitting = false;
      }
    },
    clearSelectedCand() {
      this.selectedCands = [];
      this.allSelected = false;
    },
    closeDeleteModal() {
      this.confirmModal = false;
      // this.clearSelectedCand();
    },
    showConfirm(type) {
      this.confirmType = type;
      this.confirmModal = true;
    },
    editBookmark() {
      this.folderName = JSON.parse(
        JSON.stringify(this.selectedFolder.folderName)
      );
      this.$bvModal.show("editbookmark");
    },
    closeEditBookmark() {
      this.$bvModal.hide("editbookmark");
      this.folderName = "";
      this.$v.$reset();
    },
    async exportResume(data) {
      try {
        this.LoaderStatus = true;
        let payload = {
          candidateID: data.candidateID,
        };
        const res = await getResume(payload);
        if (res.status == 200) {
          const link = res.data.data.resumeLink;
          const candidateName = res.data.data.name;

          await downloadResumeFile(link, candidateName);
          this.LoaderStatus = false;
          this.successModal("Resume downloaded successfully");
        } else {
          this.LoaderStatus = false;
        }
      } catch (error) {
        this.LoaderStatus = false;
        console.error(error);
      }
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteFolder() {
      this.bookmarkLoader = true;
      try {
        let payload = {
          licenseKey: this.licenseKey,
          folderID: this.selectedFolder.folderID,
          project: "recruitment_candidate_bookmark",
        };
        let extraData;
        if (this.confirmType != "deleteFolder") {
          extraData = {
            action: "user",
            users: this.selectedCands,
            root: true,
          };
        } else {
          extraData = {
            action: "folder",
          };
        }
        payload = { ...payload, ...extraData };
        const res = await deleteFolderUser(payload);
        if (res.status == 200) {
          let type = JSON.parse(JSON.stringify(this.confirmType));
          let count = this.selectedCands.length;
          this.closeDeleteModal();
          this.selectedCands = [];
          this.LoaderStatus = true;
          this.getBookmarkFolders();
          let toastText =
            type == "deleteFolder"
              ? "Folder deleted successfully."
              : `<strong>${count} Candidate${
                  count > 1 ? "s" : ""
                }</strong> removed sucessfully`;
          let header = type == "deleteFolder" ? "Deleted" : "Removed";
          this.dynamicToast("success", `Successfully ${header}`, toastText);
        } else this.errorModal("Something went wrong!");
        this.bookmarkLoader = false;
      } catch (error) {
        this.errorModal("Something went wrong!");
        this.bookmarkLoader = false;
        console.error(error);
      }
    },
    async bookmarkCands() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.bookmarkLoader = true;
        try {
          let payload = {
            licenseKey: this.licenseKey,
            project: "recruitment_candidate_bookmark",
            root: true,
            folderID: this.selectedFolder.folderID,
            folderName: this.folderName,
            action: "folder",
          };
          const res = await addFolderUser(payload);
          if (res.status == 200) {
            this.closeEditBookmark();
            this.LoaderStatus = true;
            this.getBookmarkFolders();
            let toastText = "Folder name updated successfully.";
            this.dynamicToast("success", "Successfully Updated", toastText);
          } else this.errorModal("Something went wrong!");
          this.bookmarkLoader = false;
        } catch (error) {
          this.errorModal("Something went wrong!");
          this.bookmarkLoader = false;
          console.error(error);
        }
      }
    },
    deselect() {
      this.allSelected = false;
      const activeCandidateIDs = this.selectedFolder.userDetails.map(
        (candidate) => candidate.candidateID
      );
      const containsAllActive = activeCandidateIDs.every((candidateID) =>
        this.selectedCands.includes(candidateID)
      );
      if (containsAllActive) {
        this.allSelected = true;
      }
    },
    selectAll() {
      for (let i in this.selectedFolder.userDetails) {
        if (
          this.allSelected &&
          this.selectedCands.filter(
            (value) => value == this.selectedFolder.userDetails[i].candidateID
          ).length === 0
        ) {
          this.selectedCands.push(
            this.selectedFolder.userDetails[i].candidateID
          );
        } else if (
          !this.allSelected &&
          this.selectedCands.filter(
            (value) => value == this.selectedFolder.userDetails[i].candidateID
          ).length > 0
        ) {
          this.selectedCands.splice(
            this.selectedCands.indexOf(
              this.selectedFolder.userDetails[i].candidateID
            )
          );
        }
      }
    },
    searchFolderIn(folderID) {
      return this.folders.filter((obj) => obj.folderID == folderID).length != 0;
    },
    async getBookmarkFolders() {
      try {
        let payload = {
          licenseKey: this.licenseKey,
          project: "recruitment_candidate_bookmark",
          searchFolder: this.searchFolder,
          searchUser: this.searchQuery,
        };
        const res = await getBookmarkFolders(payload);
        if (res.status == 200) {
          this.folders = res.data.data;
          // this.folders.map(obj => {
          //   if(!obj.users){
          //     obj.users =  [];
          //   }
          // })
          if (
            res.data.data.length != 0 ||
            this.confirmType !== "deleteFolder"
          ) {
            if (this.$route.query.folderID) {
              this.selectedFolder = res.data.data.find(
                (obj) => obj.folderID == this.$route.query.folderID
              );
              this.$router.push({ name: "Bookmark" });
            } else if (
              !this.selectedFolder.folderName ||
              !this.searchFolderIn(this.selectedFolder.folderID)
            ) {
              this.selectedFolder = this.selectedFolder = { userDetails: [] };
            } else {
              this.selectedFolder = res.data.data.find(
                (obj) => obj.folderID == this.selectedFolder.folderID
              );
            }
            // (!this.selectedFolder.folderName || this.confirmType == 'deleteFolder') || this.searchQuery
          } else this.selectedFolder = { userDetails: [] };
          this.LoaderStatus = false;
          this.searchLoading = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>
.bookmark-left-unselectedcard {
  height: 56px;
  background: #ffffff;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
  padding: 0 15px;
}
.bookmark-card-tag {
  width: 30px;
  height: 30px;
  background: #f6f9fb;
  border-radius: 100px;
}
.bm-usertag {
  padding: 1px 15px;
  border: 0.5px solid #20639b;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25));
  border-radius: 15px;
}
.bookmark-right-cards {
  padding: 2px 15px;
  height: 50px;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}
.bookmark-blue-line {
  position: absolute;
  width: 3px;
  height: 90%;
  left: 3px;
  top: 2px;
  background: #20639b;
  border-radius: 1px;
}
.bm-selected-leftcard {
  background: #20639b;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
}
</style>
